/**
 * First we will load all of this project's JavaScript dependencies which
 * include Vue and Vue Resource. This gives a great starting point for
 * building robust, powerful web applications using Vue and Laravel.
 */

import $ from 'jquery';
import Core6Lightbox from './core6/Core6Lightbox';
import Core6PagedSliderPublic from './core6/Core6PagedSliderPublic';
import Core6Utils from './core6/Core6Utilities';
import Core6Carousel from './core6/Core6Carousel';

require('./vendor/bootstrap');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the body of the page. From here, you may begin adding components to
 * the application, or feel free to tweak this setup for your needs.
 */

// Boot up Core
$(document).ready(() => {
  require('./core6/public_boot');
  require('./core6/utils');
  require('./core6/sliders');
  require('./core6/Core6Lightbox');

  const c6pagedsliderpub = new Core6PagedSliderPublic();
  c6pagedsliderpub.initPagedSliders();
  c6pagedsliderpub.startTransition();

  const lightbox = new Core6Lightbox();

  const carousels = Core6Utils.getElementAll('.coreCarouselMulti');
  for ( let i = 0; i < carousels.length; i += 1 ) {
    const componentId = carousels[i].getAttribute('data-component-id');
    const carousel = new Core6Carousel(componentId);
  }
});

$('.scrollToDesktop').click((event) => {
  event.preventDefault();
  $('html,body').animate({
    scrollTop: Core6Utils.getCoords(document.querySelector('.row_block_container')).elemTop,
  }, 600);
});

$('.scrollToMobile').click((event) => {
  event.preventDefault();
  $('html,body').animate({
    scrollTop: 0,
  }, 600);
});

function initDeferredImages() {
  // console.log("loading defer");
  const imgDefer = document.querySelectorAll('.deferred_image');
  for (let i = 0; i < imgDefer.length; i++) {
    if (imgDefer[i].getAttribute('data-src')) {
      // console.log(`Defer: ${imgDefer[i].getAttribute('data-src')}`);
      imgDefer[i].setAttribute('src', imgDefer[i].getAttribute('data-src'));
    }
  }
}

window.onload = function () {
  setTimeout(initDeferredImages, 1000);
};

$(document).ready(() => {
  $('body').on('click', 'input.cookie_accept', () => {
    // console.log('clicked');
    $.ajaxSetup({
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
      },
    });

    $.ajax({
      type: 'POST',
      url: 'cookie/accept',
      success(data) {
        $('[data-cookie_warning_container]').slideUp();
      },
      error(err) {
        console.error(err);
      },
    });
  });
});



// WEBPACK FOOTER //
// ./resources/assets/js/public.js